export const FORM = {
    STATUS: {
        PARTIAL: 'Partial',
        FULL: 'Full App'
    },
    LEAD_SOURCE_SUB: {
        SHORT: 'iframe-short',
        LONG: 'iframe-long'
    },
    LEAD_SOURCE_MEDIUM: {
        WEB: 'web'
    }
}